"use strict";

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var FbtTranslations = require("./FbtTranslations");

function fbtInit(opts) {
  FbtTranslations.registerTranslations(opts.translations);
} // OSS initialization "mixin"


require("./fbt").init = fbtInit;
module.exports = fbtInit;